// store/campaigns/types.ts

export interface Pagination {
  page: number      // zero-based page index
  size: number      // page size
  pages: number     // total pages
  elements: number  // total elements
  first: boolean
  last: boolean
}

export interface CampaignSummaryDto {
  id: string
  name: string
  status: string
  channels: string[]
  scheduled_time_utc?: string    // ISO datetime
  total_recipients?: number
  sent_count?: number
}


export type Option = { value: string; label: string };

export type AudienceType = "STATIC" | "DYNAMIC";

export interface ColumnMapping {
  form_field: { value: string; label: string };
  crm_field: Option | null;
}

export interface AudienceData {
  type: AudienceType;
  file?: File | null;
  document_key?: string;
  columns: string[];
  mappings: ColumnMapping[];
  filter_groups: any[];
  imported_count: number;
  estimated_count: number;
}

export interface RecipientEvent {
  event_type: string; // e.g., "SENT", "OPENED", "CLICKED"
  created_at: string; // ISO datetime
}

export interface Recipient {
  id: string;
  email?: string;
  phone?: string;
  status: string;
  external_data?: Record<string, any>;
  events: RecipientEvent[];
  // Optionally keep these if needed for legacy code:
  sent?: boolean;
  opened?: boolean;
  clicked?: boolean;
}

export interface TimeSeriesPoint {
  date: string;      // "2025-07-01"
  sends: number;
  opens: number;
  clicks: number;
}
export interface CampaignReportDto {
  total_recipients: number;
  sent_count: number;
  open_count: number;
  click_count: number;
  bounce_count: number;
  send_time_series: TimeSeriesPoint[];
  event_counts: Record<string, number>;
}

export interface Event {
  id: string;
  eventType: string;
  eventTime: string;
  recipientId: string;
}



// if you need more fields when viewing/editing a single campaign:
export interface CampaignDetailDto extends CampaignSummaryDto {
  description?: string
  campaign_type?: string
  audience: AudienceData;
  audience_snapshot_mode: any;
  // …any other “detail” properties
}

export enum CampaignActionTypes {
  GET_CAMPAIGNS_REQUEST = "@@campaign/GET_CAMPAIGNS_REQUEST",
  GET_CAMPAIGNS_SUCCESS = "@@campaign/GET_CAMPAIGNS_SUCCESS",
  GET_CAMPAIGNS_ERROR = "@@campaign/GET_CAMPAIGNS_ERROR",

  GET_CAMPAIGN_REQUEST = "@@campaign/GET_CAMPAIGN_REQUEST",
  GET_CAMPAIGN_SUCCESS = "@@campaign/GET_CAMPAIGN_SUCCESS",
  GET_CAMPAIGN_ERROR = "@@campaign/GET_CAMPAIGN_ERROR",

  CREATE_CAMPAIGN_REQUEST = "@@campaign/CREATE_CAMPAIGN_REQUEST",
  CREATE_CAMPAIGN_SUCCESS = "@@campaign/CREATE_CAMPAIGN_SUCCESS",
  CREATE_CAMPAIGN_ERROR = "@@campaign/CREATE_CAMPAIGN_ERROR",

  UPDATE_CAMPAIGN_REQUEST = "@@campaign/UPDATE_CAMPAIGN_REQUEST",
  UPDATE_CAMPAIGN_SUCCESS = "@@campaign/UPDATE_CAMPAIGN_SUCCESS",
  UPDATE_CAMPAIGN_ERROR = "@@campaign/UPDATE_CAMPAIGN_ERROR",

  DELETE_CAMPAIGN_REQUEST = "@@campaign/DELETE_CAMPAIGN_REQUEST",
  DELETE_CAMPAIGN_SUCCESS = "@@campaign/DELETE_CAMPAIGN_SUCCESS",
  DELETE_CAMPAIGN_ERROR = "@@campaign/DELETE_CAMPAIGN_ERROR",

  GET_CAMPAIGN_RECIPIENTS_REQUEST = "@@campaign/GET_CAMPAIGN_RECIPIENTS_REQUEST",
  GET_CAMPAIGN_RECIPIENTS_SUCCESS = "@@campaign/GET_CAMPAIGN_RECIPIENTS_SUCCESS",
  GET_CAMPAIGN_RECIPIENTS_ERROR   = "@@campaign/GET_CAMPAIGN_RECIPIENTS_ERROR",

  GET_CAMPAIGN_REPORT_REQUEST   = "@@campaign/GET_CAMPAIGN_REPORT_REQUEST",
  GET_CAMPAIGN_REPORT_SUCCESS   = "@@campaign/GET_CAMPAIGN_REPORT_SUCCESS",
  GET_CAMPAIGN_REPORT_ERROR     = "@@campaign/GET_CAMPAIGN_REPORT_ERROR",

  GET_CAMPAIGN_EVENTS_REQUEST   = "@@campaign/GET_CAMPAIGN_EVENTS_REQUEST",
  GET_CAMPAIGN_EVENTS_SUCCESS   = "@@campaign/GET_CAMPAIGN_EVENTS_SUCCESS",
  GET_CAMPAIGN_EVENTS_ERROR     = "@@campaign/GET_CAMPAIGN_EVENTS_ERROR",
}

export interface CampaignState {
  readonly list: CampaignSummaryDto[]
  readonly pagination: Pagination | null
  readonly current?: CampaignDetailDto
  readonly loading: boolean
  readonly error: string | null

  report?: CampaignReportDto;
  events: Event[];
  eventsPagination: Pagination | null;

  readonly recipients: Recipient[];
  readonly recipientsPagination: Pagination | null;
  readonly recipLoading: boolean;
  readonly recipError: string | null;
  eventsLoading: boolean;
  eventsError: string | null;
}
